module.exports = __webpack_public_path__ + "static/media/21ECLAC2.56c1ef18.jpg";